import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getJobTypes } from "./Axios";

const JobTypeSelect = props => {
  const [job_types, setJobTypes] = useState([]);

  const handleChange = selectedOption => {
    props.handleChange(selectedOption, "job_type");
  };

  useEffect(() => {
    getJobTypes((response) => {
      if (response && response.data) {
        const newJobTypes = response.data.map((job_type) => ({
          value: job_type.id,
          label: job_type.name,
          uniqueIdentifier: job_type.unique_identifier,
        }));
        setJobTypes(newJobTypes);
      }
    });
  }, []);

  return (
    <Select
      inputId="trabajando-job-type-search"
      onChange={handleChange}
      options={job_types}
      placeholder="Buscar y seleccionar un cargo"
      value={
        job_types.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label}`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label } = option.data;
        return (
          label.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default JobTypeSelect;

